/**
 * App look marker.
 *
 * Bunker has one look: HeroUI components under the cispracs palette layer.
 * `data-skin="cispracs"` on <html> keys the `[data-skin='cispracs']` CSS
 * (radii, frameless panels, chat surfaces); the palette itself comes from
 * theme.ts and the font from fontPreference.ts.
 *
 * Older builds let users pick the retired HeroUI look and saved it as
 * `bunker.cispracs = '0'`; hydrateSkin() wipes that key.
 */

const LEGACY_CHOICE_KEY = 'bunker.cispracs';

/**
 * Call once at boot, before React mounts, so the first paint already carries
 * the right CSS layer.
 */
export function hydrateSkin(): void {
  try {
    localStorage.removeItem(LEGACY_CHOICE_KEY);
  } catch {
    /* storage blocked: nothing saved to wipe */
  }
  if (typeof document === 'undefined') return;
  document.documentElement.dataset.skin = 'cispracs';
}
